import { QueryClientProvider } from '@tanstack/react-query';
import { HashRouter } from 'react-router-dom';

import AppGate from './app-gate';
import AppRouter from './router';
import { queryClient } from '../core/network/query-client';
import { AuthProvider } from '../global/contexts/auth/auth';
import { DeviceProvider } from '../global/contexts/device/device';
import { NoticeProvider } from '../global/contexts/notice/notice';
import { ThemeProvider } from '../global/contexts/theme/theme';

// HashRouter instead of BrowserRouter: the bundle runs from file-like
// origins (Capacitor, iframes under a sub-path, static hosting without SPA
// fallback). See docs/decisions/001-hash-routing.md.
export default function App() {
    return (
        <HashRouter>
            <AuthProvider>
                <QueryClientProvider client={queryClient}>
                    <ThemeProvider>
                        <NoticeProvider>
                            <DeviceProvider>
                                <AppGate>
                                    <AppRouter />
                                </AppGate>
                            </DeviceProvider>
                        </NoticeProvider>
                    </ThemeProvider>
                </QueryClientProvider>
            </AuthProvider>
        </HashRouter>
    );
}
